<template>
  <div class="logManagement mainPageBg">
    <div class="logContent commonOrderContent">
      <div class="formBox">
        <el-form :inline="true"
          :model="formInline"
          class="demo-form-inline">
          <el-form-item label="选择日期">
            <el-date-picker v-model="formInline.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用户">
            <el-input v-model="formInline.name"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="操作">
            <el-select v-model="formInline.operation">
              <!-- <el-option label="设备" value="DEVICE"></el-option>
              <el-option label="区域" value="REGION"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="操作对象">
            <el-select v-model="formInline.objects">
              <!-- <el-option label="设备" value="DEVICE"></el-option>
              <el-option label="区域" value="REGION"></el-option> -->
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain
              icon="el-icon-download"
              v-if="judgeAuthority('rizhi:logManagement:export')">EXCEL</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tabCardBox">
        <div class="orderCardItem">
          <el-table :data="tableData"
            stripe
            border
            style="width: 100%"
            class="tabWrap"
            height="93%"
            :header-cell-style="{
              'background-color': '#F7F7F7',
            }">
            <el-table-column v-for="(v, i) in tabHead"
              :key="i"
              :prop="v.prop"
              :label="v.label"
              min-width="60"
              :show-overflow-tooltip="true"
              align="center"></el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 30, 50]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            style="margin-top: 10px; text-align: right">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFtt, judgeAuthority } from "@/assets/js/utils";
export default {
  data() {
    return {
      formInline: {
        time: [],
        operation: "",
        name: "",
      },
      tabHead: [
        { label: "序号", prop: "id" },
        { label: "时间", prop: "time" },
        { label: "登录IP", prop: "ip" },
        { label: "用户", prop: "user" },
        { label: "操作", prop: "operation" },
        { label: "操作对象", prop: "objects" },
        { label: "原值", prop: "originalValue" },
        { label: "新值", prop: "newValue" },
      ],
      tableData: [
        {
          id: 1,
          time: "2022.09.09 12:22:33",
          ip: "192.168.1.1",
          user: "admin",
          operation: "确认",
          objects: "工单“工单ID信息”",
          originalValue: "待处理",
          newValue: "已确认",
        },
        {
          id: 2,
          time: "2022.09.09 12:22:33",
          ip: "192.168.1.1",
          user: "admin",
          operation: "关闭",
          objects: "工单“工单ID信息”",
          originalValue: "待处理",
          newValue: "已确认",
        },
        {
          id: 3,
          time: "2022.09.09 12:22:33",
          ip: "192.168.1.1",
          user: "admin",
          operation: "派单",
          objects: "工单“工单ID信息”",
          originalValue: "待处理",
          newValue: "已确认",
        },
        {
          id: 4,
          time: "2022.09.09 12:22:33",
          ip: "192.168.1.1",
          user: "admin",
          operation: "导出",
          objects: "工单“工单ID信息”",
          originalValue: "待处理",
          newValue: "已确认",
        },
        {
          id: 5,
          time: "2022.09.09 12:22:33",
          ip: "192.168.1.1",
          user: "admin",
          operation: "登录",
          objects: "系统",
          originalValue: "待处理",
          newValue: "已确认",
        },
        {
          id: 6,
          time: "2022.09.09 12:22:33",
          ip: "192.168.1.1",
          user: "admin",
          operation: "编辑",
          objects: "用户“张三”",
          originalValue: "待处理",
          newValue: "已确认",
        },
      ],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
    };
  },
  methods: {
    judgeAuthority,
    handleSizeChange() {},
    handleCurrentChange() {},
  },
};
</script>

<style lang="scss" scoped>
.logManagement {
  @include setFlexCenter;
  .logContent {
    width: 98%;
    height: 96%;
    ::v-deep .el-select .el-input__inner {
      vertical-align: bottom !important;
    }
    ::v-deep .el-input--suffix .el-input__inner {
      vertical-align: bottom !important;
    }
  }
}
</style>